import { c as _c } from "react/compiler-runtime";
import type { Point } from '@morpho-org/dapp-core';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/common/overlays';
import { ButtonLink } from '../ButtonLink';
export interface PointInfoHoverCardProps {
  point: Point;
}
const PointInfoHoverCard = t0 => {
  const $ = _c(16);
  const {
    point
  } = t0;
  if (point.noHoverCard) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HoverCardTrigger asChild={true}><div className="flex"><InfoTooltip disabled={true} /></div></HoverCardTrigger>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: "275px",
      maxWidth: "315px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      textAlign: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = point.title ? `${point.title} campaign` : "Campaign";
  let t5;
  if ($[3] !== t4) {
    t5 = <span className="text-md" style={t3}>{t4}</span>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      textAlign: "center"
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = point.label ? ` by ${point.label}` : "";
  let t8;
  if ($[6] !== t7) {
    t8 = <span className="text-2xs" style={t6}>This points campaign is administered independently{t7}. The Morpho Association is not responsible for determining eligibility, distribution, or the accuracy of the information displayed.</span>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5 || $[9] !== t8) {
    t9 = <div className="gap-sm flex flex-col">{t5}{t8}</div>;
    $[8] = t5;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== point.link) {
    t10 = point.link && <ButtonLink mode="external" href={point.link} buttonProps={{
      label: "Learn more",
      size: "default",
      variant: "secondary",
      style: {
        width: "100%"
      }
    }} />;
    $[11] = point.link;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <HoverCard openDelay={200} closeDelay={100}>{t1}<HoverCardContent style={t2} side="top" sideOffset={8} onClick={_temp}><div className="gap-md p-md flex flex-col">{t9}{t10}</div></HoverCardContent></HoverCard>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
};
export default memo(PointInfoHoverCard);
function _temp(e) {
  return e.stopPropagation();
}